export class StructureControlState {

    Running: boolean;
    Success: boolean;

    constructor(running?: boolean, success?: boolean) {
        this.Running = running;
        this.Success = success;
    }
}